import type {
  ApprovalModule,
  ApprovalRequest,
  ApprovalRequestDetail,
  ApprovalRequestFilterInput,
  ApprovalRequestFilters,
  ApprovalRequestState,
} from "./models";

export const approvalStates = [
  "PENDING",
  "APPROVED",
  "REJECTED",
  "CHANGES_REQUESTED",
  "APPLYING",
  "APPLIED",
  "APPLIED_WITH_EXCEPTIONS",
  "APPLY_FAILED",
  "FAILED",
  "EXPIRED",
  "CANCELLED",
  "SUPERSEDED",
] as const satisfies readonly ApprovalRequestState[];
export const approvalModules = [
  "DESTINATIONS",
  "EXPERIENCES",
  "LEGAL",
  "PARTNERS",
  "PARTNER_CONTACTS",
  "PARTNER_IMPORT",
  "PARTNER_OFFERINGS",
  "PARTNER_SCHEDULES",
  "USER_MODERATION",
] as const satisfies readonly ApprovalModule[];
export const approvalAges = [
  "LAST_24_HOURS",
  "LAST_7_DAYS",
  "LAST_30_DAYS",
  "OLDER_THAN_30_DAYS",
] as const;
export function approvalFilters(input?: ApprovalRequestFilterInput): ApprovalRequestFilters {
  return typeof input === "string" ? { state: input } : (input ?? {});
}
export function validApprovalFilters(input: ApprovalRequestFilters): boolean {
  return (
    Boolean(input) &&
    typeof input === "object" &&
    !Array.isArray(input) &&
    Object.keys(input).every((key) =>
      [
        "state",
        "module",
        "requesterUserId",
        "requesterSearch",
        "queue",
        "age",
        "partnerId",
        "openWork",
      ].includes(key),
    ) &&
    (input.partnerId === undefined ||
      (typeof input.partnerId === "string" &&
        input.partnerId.length > 0 &&
        input.partnerId.length <= 64)) &&
    (input.openWork === undefined || input.openWork === "true") &&
    (input.queue === undefined || ["NEEDS_REVIEW", "MY_SUBMISSIONS"].includes(input.queue)) &&
    (input.requesterSearch === undefined ||
      (typeof input.requesterSearch === "string" && input.requesterSearch.length <= 100)) &&
    (input.state === undefined || approvalStates.includes(input.state)) &&
    (input.module === undefined || approvalModules.includes(input.module)) &&
    (input.age === undefined || approvalAges.includes(input.age)) &&
    (input.requesterUserId === undefined ||
      (typeof input.requesterUserId === "string" &&
        input.requesterUserId.length > 0 &&
        input.requesterUserId.length <= 64))
  );
}

/** Match the API list projection; never copy a detail payload, decision or timeline into inbox data. */
export function approvalInboxItem(request: ApprovalRequestDetail): ApprovalRequest {
  return {
    actionCode: request.actionCode,
    createdAt: request.createdAt,
    entityId: request.entityId,
    entityType: request.entityType,
    id: request.id,
    moduleCode: request.moduleCode,
    reason: request.reason,
    requestDigest: request.requestDigest,
    requesterUserId: request.requesterUserId,
    supersedesRequestId: request.supersedesRequestId,
    supersededByRequestId: request.supersededByRequestId,
    blockedReason: request.blockedReason,
    blockedAt: request.blockedAt,
    decidedAt: request.decidedAt,
    appliedAt: request.appliedAt,
    cancelledAt: request.cancelledAt,
    supersededAt: request.supersededAt,
    state: request.state,
    updatedAt: request.updatedAt,
    version: request.version,
  };
}
